export const online = "online";
export const offline = "offline";
